<div class="right_col screen-height v_scrnss edit-page" role="main">
  <div class="container-fluid">
    <div class="row pt-4 pb-3">
      <div class="col-12">
        <h1 class="text-left font-weight-bold text-uppercase text-dark">Manage Reports & Appeals</h1>
      </div>
    </div>

    <ul class="nav nav-tabs mb-4">
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab === 'reports'" (click)="setTab('reports')" style="cursor:pointer">Reports</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab === 'appeals'" (click)="setTab('appeals')" style="cursor:pointer">Appeals</a>
      </li>
    </ul>

    <div class="tab-content">
      <!-- Reports Tab -->
      <div *ngIf="activeTab === 'reports'" class="tab-pane active">
        <div class="card shadow-sm">
          <div class="card-body">
            <table *ngIf="renderReports" datatable [dtOptions]="dtOptions" [class.d-none]="reports.length === 0" class="table table-striped table-bordered w-100">
              <thead>
                <tr>
                  <th>Reporter</th>
                  <th>Reported User</th>
                  <th>Reason</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let r of reports">
                  <td>
                    <div><strong>{{ r.reporterName || 'Unknown' }}</strong></div>
                    <div class="text-muted small">{{ r.reporterEmail || r.reporterId || 'N/A' }}</div>
                  </td>
                  <td>
                    <div><strong>{{ r.reportedName || 'Unknown' }}</strong></div>
                    <div class="text-muted small">{{ r.reportedEmail || r.reportedUserId || 'N/A' }}</div>
                  </td>
                  <td>{{ r.reason }}</td>
                  <td>{{ r.createdAt | date:'short' }}</td>
                  <td>
                    <button class="btn btn-warning btn-sm mr-2" (click)="actionReport(r, 'flag')">Flag</button>
                    <button class="btn btn-secondary btn-sm" (click)="actionReport(r, 'dismiss')">Dismiss</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div *ngIf="reports.length === 0" class="text-center py-4 text-muted">No pending reports found.</div>
          </div>
        </div>
      </div>

      <!-- Appeals Tab -->
      <div *ngIf="activeTab === 'appeals'" class="tab-pane active">
        <div class="card shadow-sm">
          <div class="card-body">
            <table *ngIf="renderAppeals" datatable [dtOptions]="dtOptions" [class.d-none]="appeals.length === 0" class="table table-striped table-bordered w-100">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Message</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let a of appeals">
                  <td>
                    <div><strong>{{ a.userName || 'Unknown' }}</strong></div>
                    <div class="text-muted small">{{ a.userEmail || a.userId || 'N/A' }}</div>
                  </td>
                  <td>{{ a.message }}</td>
                  <td>{{ a.createdAt | date:'short' }}</td>
                  <td>
                    <button class="btn btn-success btn-sm mr-2" (click)="actionAppeal(a, 'release')">Release</button>
                    <button class="btn btn-danger btn-sm" (click)="actionAppeal(a, 'block')">Block</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div *ngIf="appeals.length === 0" class="text-center py-4 text-muted">No pending appeals found.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Confirmation Modal -->
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display': isModalOpen ? 'block' : 'none'}" style="background: rgba(0,0,0,0.5);">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ modalTitle }}</h5>
        <button type="button" class="close" (click)="closeModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{{ modalMessage }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="onConfirmModal()">Confirm</button>
      </div>
    </div>
  </div>
</div>
